import {
  ACCOUNT_LOGIN_FAILURE,
  ACCOUNT_LOGIN_LOAD,
  ACCOUNT_LOGIN_SUCCESS,
  COGNITO_LOGIN_USER,
  SET_USER,
  COGNITO_LOGIN_ATTEMPT,
  ACCOUNT_LOGIN_RESET,
  ACCOUNT_LOGOUT,
  ACCOUNT_FORGOT_PASSWORD_FAILURE,
  ACCOUNT_FORGOT_PASSWORD_SUCCESS,
  ACCOUNT_FORGOT_PASSWORD_ATTEMPT,
  LOAD_COMPANY,
  UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  ACCOUNT_SET_PREFERENCES,
  ACCOUNT_SET_PREFERENCES_HIDE_LOADING,
  ACCOUNT_SET_PREFERENCES_SHOW_LOADING,
  ACCOUNT_SET_USER_NOTIFICATION_PREFERENCES
} from './actionTypes'

export const forgotPasswordFailure = () => ({
  type: ACCOUNT_FORGOT_PASSWORD_FAILURE,
  meta: {},
  payload: {}
})

export const forgotPasswordSuccess = () => ({
  type: ACCOUNT_FORGOT_PASSWORD_SUCCESS,
  meta: {},
  payload: {}
})

export const forgotPasswordAttempt = (email) => ({
  type: ACCOUNT_FORGOT_PASSWORD_ATTEMPT,
  meta: {},
  payload: { email }
})

export const cognitoLoginAttempt = (data) => ({
  type: COGNITO_LOGIN_ATTEMPT,
  meta: {},
  payload: data
})

export const loginFailure = (error) => ({
  type: ACCOUNT_LOGIN_FAILURE,
  meta: {},
  payload: { error }
})

export const loginLoad = () => ({
  type: ACCOUNT_LOGIN_LOAD,
  meta: {},
  payload: {}
})

export const loginSuccess = (token, user, company) => ({
  type: ACCOUNT_LOGIN_SUCCESS,
  meta: {},
  payload: {
    token,
    user,
    company
  }
})

export const cognitoLoginError = (error) => ({
  type: ACCOUNT_LOGIN_FAILURE,
  meta: {},
  payload: { error: { errorCode: error.code } }
})

export const cognitoLoginUser = (data) => ({
  type: COGNITO_LOGIN_USER,
  meta: {},
  payload: data
})

export const setUser = (data) => ({
  type: SET_USER,
  meta: {},
  payload: data
})

export const loginReset = () => ({
  type: ACCOUNT_LOGIN_RESET,
  meta: {},
  payload: {}
})

export const logout = () => ({
  type: ACCOUNT_LOGOUT,
  meta: {},
  payload: {}
})

export const loadCompany = (options) => ({
  type: LOAD_COMPANY,
  meta: {},
  payload: options
})

export const updateCompany = (options) => ({
  type: UPDATE_COMPANY,
  meta: {},
  payload: options
})

export const updateCompanySuccess = (options) => ({
  type: UPDATE_COMPANY_SUCCESS,
  meta: {},
  payload: options
})

export const setPreferences = (data) => ({
  type: ACCOUNT_SET_PREFERENCES,
  meta: {},
  payload: data
})

export const setUserNotificationPreferences = (data) => ({
  type: ACCOUNT_SET_USER_NOTIFICATION_PREFERENCES,
  meta: {},
  payload: data
})

export const setPreferencesShowLoading = () => ({
  type: ACCOUNT_SET_PREFERENCES_SHOW_LOADING,
  meta: {},
  payload: {}
})

export const setPreferencesHideLoading = (data) => ({
  type: ACCOUNT_SET_PREFERENCES_HIDE_LOADING,
  meta: {},
  payload: data
})

export default {
  forgotPasswordFailure,
  forgotPasswordSuccess,
  forgotPasswordAttempt,
  cognitoLoginAttempt,
  cognitoLoginUser,
  setUser,
  cognitoLoginError,
  loginFailure,
  loginLoad,
  loginSuccess,
  loginReset,
  logout,
  loadCompany,
  updateCompany,
  updateCompanySuccess,
  setPreferences,
  setUserNotificationPreferences,
  setPreferencesShowLoading,
  setPreferencesHideLoading
}
